export default "__VITE_ASSET__O1oUDDAP__"